import * as consts from './GalleryConsts';

const initialState = {
    activeSlideName: '',
    imageSizeParams: {
        thumbnail: '?w=118&h=86',
        original: '?w=404&h=295',
        walk: '?w=640&h=480',
        wide: '?w=1024&h=680',
        fullhd: '?w=1920&h=1276'
    },
    galleryExists: false,
    imagesPath: '',
    images: [],
    visitedSlides: new Set([0]),
    galleryVisible: true,
    getGalleryFulfilled: false
};

const gallery = (state = initialState, action) => {
    switch (action.type) {
        case consts.SET_ACTIVE_SLIDER:
            return {
                ...state,
                activeSlideName: action.payload.activeSlideName,
                visitedSlides: action.payload.visitedSlides
            }
        case consts.TOGGLE_VISIBILITY:
            return {
                ...state,
                galleryVisible: !state.galleryVisible
            }
        case consts.GET_GALLERY_FULFILLED:
            if (!action.payload.gallery) {
                return initialState
            }

            return {
                ...state,
                imagesPath: action.payload.gallery.base_path,
                images: action.payload.gallery.images,
                galleryBtnVisible: !!+action.payload.gallery.images.length,
                getGalleryFulfilled: true
            }
        default:
            return state
    }
}

export default gallery;
